<template>
  <div v-if="superAdmin || userRole == 'admin'">
      <v-layout wrap row justify-start pa-2 py-5>
        <v-flex xs6 px-2>
          <v-card class="elevation-24 text-md-center">
            <v-card-title class="headline white--text primary">
							Warehouse
						</v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-dialog v-model="dialog" persistent max-width="290">
                <v-btn color="primary" dark slot="activator">add a warehouse</v-btn>
                <v-card>
                  <v-card-title class="headline">New Warehouse</v-card-title>
                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-select
                          :items="countries"
                          solo
                          v-model="nwarehouse.country"
                          label="Country"
                        ></v-select>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                          label="Name"
                          solo
                          v-model="nwarehouse.name"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="error" flat @click="dialog=false">close</v-btn>
                    <v-btn @click="warehouseAdd()" :loading="loading" color="success" dark>
                      add warehouse
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <v-dialog v-model="dialogImport" persistent max-width="700">
                <v-btn color="primary" class="ml-2" dark slot="activator" v-if="superAdmin">Import to Warehouses</v-btn>
                <v-card>
                  <v-card-title class="headline">Import Products</v-card-title>
                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex xs12 md12 pa-1>
                        <v-textarea
                          label="Keys OR Document Numbers"
                          v-model="pastedData"
                          solo
                        ></v-textarea>
                      </v-flex>
                      <v-flex xs12 class="title text-xs-center">
                        {{importDone}} / {{importTotal}}
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="error" flat @click.native="dialogImport = false">Cancel</v-btn>
                    <v-btn color="primary" @click.native="importWarehouses()">Import</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-card-actions>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs11>
                  <v-select
                    :items="warehouses"
                    solo
                    :disabled="loading || syncing"
                    :loading="loading"
                    return-object
                    v-model="selectedWarehouse"
                    label="Warehouse"
                    @change="loadWarehouseProducts"
                    item-text="text"
                  ></v-select>
                </v-flex>
                <v-flex xs1>
                  <v-avatar
                    size="12"
                    v-if="selectedWarehouse"
                    :color="`${selectedWarehouse.lock? 'error' : 'success'}`"
                  >
                  </v-avatar>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" :disabled="!selectedWarehouse" @click="lockWarehouseh(selectedWarehouse)">lock warehouse</v-btn>
              <v-btn color="primary" :disabled="!selectedWarehouse" @click="unlockWarehouseh(selectedWarehouse)">unlock warehouse</v-btn>
              <v-btn color="primary" :disabled="!selectedWarehouse" @click="exportWarehouseh()">Export warehouse</v-btn>
            </v-card-actions>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12 v-if="selectedWarehouse">
                  <v-layout row wrap style="height:600px;overflow-y:scroll;">
                    <v-flex xs12 px-1>
                      <v-layout row wrap>
                        <v-flex xs3 style="font-weight:bold;">
                          SKU
                        </v-flex>
                        <v-flex xs3 style="font-weight:bold;">
                          Name
                        </v-flex>
                        <v-flex xs1 style="font-weight:bold;">
                          QYT
                        </v-flex>
                        <v-flex xs1 style="font-weight:bold;">
                          RES
                        </v-flex>
                        <v-flex xs1 style="font-weight:bold;">
                          EXP
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 v-for="(product, i) in selectedWarehouse.products" :key="'warehouseProducts'+i" px-1>
                      <v-card class="pa-2">
                        <v-layout row wrap>
                          <v-flex xs3>
                            {{product.sku}}
                          </v-flex>
                          <v-flex xs3>
                            {{product.item_name}} 
                          </v-flex>
                          <v-flex xs1>
                            {{product.warehouses.filter(x=>x.warehouse==selectedWarehouse.name)[0].quantity}}
                          </v-flex>
                          <v-flex xs1>
                            {{product.warehouses.filter(x=>x.warehouse==selectedWarehouse.name)[0].reserved}}
                          </v-flex>
                          <v-flex xs1>
                            {{product.warehouses.filter(x=>x.warehouse==selectedWarehouse.name)[0].expected}}
                          </v-flex>
                          <v-flex xs3>
                            <v-btn color="success" flat small @click="selectedProduct = products.filter(x=>x.key == product.key)[0]">edit</v-btn>
                          </v-flex>
                        </v-layout>
                        <v-divider></v-divider>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs6 px-2>
          <v-card class="elevation-24 text-md-center">
            <v-card-title class="headline white--text primary">
							Products 
              <v-spacer></v-spacer>
              {{backupsku}}
              <v-spacer></v-spacer>
              <v-btn color="secondary" :loading="loading" :disabled="loading" @click="backupProducts()">backup
              </v-btn>
						</v-card-title>
            <v-card-actions v-if="false">
              <v-spacer></v-spacer>
              <v-dialog v-model="dialogAdd" persistent max-width="290">
                <v-card>
                  <v-card-title class="headline">Add a new Product?</v-card-title>
                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-text-field
                          label="Product Name"
                          required
                          v-model="nName"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                          label="Product SKU"
                          required
                          v-model="nSKU"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" flat @click="dialogAdd = false">Cancel</v-btn>
                    <v-btn :disabled="!nName || !nSKU" color="primary" flat @click="addProduct()">add</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <v-btn color="primary" @click="dialogAdd = true" :loading="syncing" :disabled="syncing">add Product</v-btn>
              <!-- <v-btn color="primary" @click="syncProducts()" :loading="syncing" :disabled="syncing">Sync Products</v-btn> -->
            </v-card-actions>
            <v-card-text>
              <v-layout row wrap>
								<v-flex xs12 md12 pa-1>
									<v-autocomplete
                    label="Products"
                    :items="products"
                    v-model="selectedProduct"
                    item-text="item_name"
                    return-object
                    :disabled="loading || syncing"
                    :loading="loading"
                    solo
                  ></v-autocomplete>
              	</v-flex>                
              </v-layout>
              <v-layout row wrap v-if="selectedProduct">
								<v-flex v-for="(warehouse, k) in selectedProduct.warehouses" :key="k" xs12>
									<v-card>
										<v-layout row wrap align-center pa-4>
											<v-flex xs6 px-1>
												Warehouse
												<v-autocomplete
													:items="warehouses"
													v-model="selectedProduct.warehouses[k].warehouse"
													label="Select a warehouse"
													solo
													clearable
                          item-value="name"
                          item-text="name"
													hide-details
													:loading="loading"
													:append-outer-icon="`${(( userRole == 'admin') ? 'add' : '')}`"
													@click:append-outer="dialog = true"
												></v-autocomplete>
											</v-flex>
											<v-flex xs4 px-1>
												Quantity
												<v-text-field
													v-model="selectedProduct.warehouses[k].quantity"
													hide-details
                          disabled
                          readonly
													@keypress="isNumber($event)"
													solo
												></v-text-field>
											</v-flex>
											<v-flex v-if="superAdmin" xs1 class="text-xs-center">
												<v-btn @click="removeWearhouse(k)" color="error" icon flat dark px-2>
													<v-icon size="16px">close</v-icon>
												</v-btn>
											</v-flex>
										</v-layout>
									</v-card>
								</v-flex>
								<v-flex xs12 class="text-xs-center">
									<v-btn @click="addWarehouse(selectedProduct.key)" color="primary" dark px-2>
										<v-icon left size="16px">add</v-icon>
										add a warehouseh
									</v-btn>
									<v-btn @click="saveWareHousesToProduct()" color="success" 
										v-if="selectedProduct.warehouse && selectedProduct.warehouse.length > 0" 
										dark 
										px-2>
										<v-icon left size="16px">save</v-icon>
										save warehousing
									</v-btn>
								</v-flex>
							</v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
							<!-- <v-btn @click="updateByKey()" :loading="loading" color="success" dark>
                update keys with values
              </v-btn> -->
              <v-btn color="primary" @click="updateProduct()">update product</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
  </div>
</template>

<script>
import { firebase, db, auth, createFirebase, store } from '@/fb';
import { getRandomInt, randomString, getCDate} from '@/customFunction';
import axios from 'axios';
import { productApiUrl } from '@/config/urls';
export default {
  data(){
    return {
			loading: false,
      products:[],
      syncing:false,
      selectedProduct:null,
      countries:[],
      warehouses:[],
      nwarehouse:{},
      selectedWarehouse:null,
      dialog: false,
      nName:null,
      nSKU:null,
      dialogAdd: false,
      dialogImport: false,
      pastedData:null,
      delimiter:null,
      importTotal:0,
      importDone:0,
      backupsku:null,
      fullProducts:null,
      laravelProducts: null,
    }
  },
  methods: {
    async lockWarehouseh(wh) {
      this.loading = true
      await store.collection('warehouses').doc(wh.key).update({lock:true})
      await this.getWarehouses()
      this.loading = true
    },
    async unlockWarehouseh(wh) {
      this.loading = true
      await store.collection('warehouses').doc(wh.key).update({lock:false})
      await this.getWarehouses()
      this.loading = true
    },
    clipboardSuccessHandler ({ value, event }){
      this.$emit('snackbarNotification', `Copied`, 'success')
    },
    clipboardErrorHandler ({ value, event }) {
      this.$emit('snackbarNotification', `Failed`, 'error')
    },
    isNumber(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
		guessDelimiters (text, possibleDelimiters) {
			return possibleDelimiters.filter(weedOut);
			function weedOut (delimiter) {
				var cache = -1;
				return text.split('\n').every(checkLength);
				function checkLength (line) {
					if (!line) {
							return true;
					}
					var length = line.split(delimiter).length;
					if (cache < 0) {
							cache = length;
					}
					return cache === length && length > 1;
				}
			}
		},
		getArray(){
			let csv = this.pastedData
			let dels = [' ', '  ', ',', '	', '\t']
			this.delimiter = ','
			if(this.delimiter && this.delimiter > 1) {
				this.$emit('snackbarNotification', `Please export as CSV`, 'error')
				return
			}
			var lines=csv.split("\n");
      var result = [];
			var headers=lines[0].split(this.delimiter);
			for(var i=1;i<lines.length;i++){
					if (!lines[i])
							continue
					var obj = {};
					var currentline=lines[i].split(this.delimiter);
					for(var j=0;j<headers.length;j++){
							obj[headers[j]] = currentline[j];
					}
					result.push(obj);
			}
			return result
    },
    async importWarehouses(){
      let b = this.getArray()
      this.importTotal = b.length
      this.importDone = 0
      console.log('------------------------------------');
      console.log(b);
      console.log('------------------------------------');
      (async x=>{
        for (let i = 0; i < b.length; i++) {
          const item = b[i];
          let p = await store.collection(`products`).where('sku', '==', item.sku.trim()).get().then(x=>x.docs.map(y=>y.data())[0])
          if(p){
            let w = this.warehouses.map(x=>x.name)
            for (let k = 0; k < w.length; k++) {
              const wa = w[k];
              if(item[wa]){
                if(!p.warehouses) p.warehouses = []
                if(p.warehouses && !p.warehouses.map(x=>x.warehouse).includes(wa)) {
                  p.warehouses.push({
                    quantity:item[wa] && item[wa] != '' ? item[wa] : '0',
                    warehouse:wa
                  })
                } else if(p.warehouses && p.warehouses.map(x=>x.warehouse).includes(wa)){
                  let ind = p.warehouses.map(x=>x.warehouse).indexOf(wa)
                  p.warehouses[ind] = {
                    quantity:item[wa] && item[wa] != '' ? item[wa] : '0',
                    warehouse:wa
                  }
                }
              }
            }
            console.log(p)
            await store.collection('products').doc(p.key).update(p)
			      // await store.collection('productsLive').doc(p.key).set(p)
          } else {
            //   let product = {
            //     item_name:item.item_name,
            //     sku:item.sku,
            //   }
            //   let w = this.warehouses.map(x=>x.name)
            //   for (let k = 0; k < w.length; k++) {
            //     const wa = w[k];
            //     if(!product.warehouses) product.warehouses = []
            //     if(product.warehouses && !product.warehouses.map(x=>x.warehouse).includes(wa)) {
            //       product.warehouses.push({
            //         quantity:item[wa] && item[wa] != '' ? item[wa] : '0',
            //         warehouse:wa
            //       })
            //     }
            //   }
            //   // let x = await db.ref(`products`)
            //   // .push(product);
            //   product.key = x.key;
            //   await store.collection('products').doc(product.key).set(product)
            //   // await store.collection('productsLive').doc(product.key).set(product)
          }
          this.importDone = i
        }
      })()
    },
    // async syncProducts() {
    //   this.syncing = true
    //   let a = await db.ref(`products`).once('value').then(x=>x.val())
    //   console.log(a)
    //   let k = Object.keys(a)
    //   let b = Object.values(a).map((x, i)=>{
    //     return {
    //       key:k[i],
    //       sku:x.sku,
    //       item_name:x.item_name,
    //     }
    //   }).filter(x=>x.key && x.sku && x.item_name)
    //   console.log(b);
    //   (async x=>{
    //     for (let i = 0; i < b.length; i++) {
    //       const p = b[i];
    //       let t = await store.collection('products').doc(p.key).get().then(x=>x.data())
    //       if(!t){
    //         await store.collection('products').doc(p.key).set(p)
    //         console.log(i);
    //       }
    //     }
    //     this.syncing = false
    //     this.getProducts()
    //   })()
    // },
    async getProducts(k){
      return new Promise(async (res, rej)=>{
        this.loading = true
        let full = await db.ref('products').once('value').then(x=>x.val())
        let ks = Object.keys(full)
        this.fullProducts = Object.values(full).map((x, i)=>{
          return {...x, key:ks[i]}
        })
        this.products = await store.collection('products').get()
        .then(x=>x.docs.map(y=>{
          return {
            ...y.data(),
            key:y.id,
            warehouses:y.data().warehouses? y.data().warehouses:[]
          }
        }))
        console.log(this.products)
        if(k){
          this.selectedProduct = this.products.filter(x=>x.key == k)[0]
        }
        this.loading = false
        res()
      })
    },
    async loadLaravelProducts(){
      return new Promise(async (res, rej)=>{
        let laraProducts = await axios.get(productApiUrl('products-all')).then(x => x.data.products)
        let laraSubs = await axios.get(productApiUrl('products-all')).then(x => x.data.subs)
        let all_products = [...laraProducts, ...laraSubs].map(x=>{return {sku:x.sku, account_id:x.account_id}})
        console.log('loadLaravelProducts', all_products)
        this.laravelProducts = all_products
        res(all_products)
      })
    },
    async getLiveProducts(){
      return new Promise(async (res, rej)=>{
        this.loading = true
        let live_products = await store.collection('productsLive').get()
        .then(x=>x.docs.map(y=>{
          return {
            ...y.data(),
            key:y.id,
            warehouses:y.data().warehouses? y.data().warehouses:[]
          }
        }))
        res(live_products)
        this.loading = false
      })
    },
    async warehouseAdd(){
      this.loading = true
      await store.collection('warehouses').add(this.nwarehouse)
      let live_products = await this.getLiveProducts()
      let p = this.products;
      this.dialog = false
      console.log(p);
      (async x=>{
        for (let i = 0; i < p.length; i++) {
          const product = p[i];
          if(!product.warehouses) product.warehouses = []
          this.backupsku = product.sku
          product.warehouses.push({
            warehouse:this.nwarehouse.name,
            quantity:0,
          })
          await store.collection('products').doc(product.key).update({warehouses:product.warehouses})
        }
        for (let i = 0; i < live_products.length; i++) {
          const product = live_products[i];
          if(!product.warehouses) product.warehouses = []
          this.backupsku = product.sku
          product.warehouses.push({
            warehouse:this.nwarehouse.name,
            quantity:0,
            alternatives:[]
          })
          await store.collection('productsLive').doc(product.key).update({warehouses:product.warehouses})
        }
        this.loading = false
        await this.getWarehouses()
      })()
    },
    async backupProducts() {
      let p = await store.collection(`products`).get().then(x=>x.docs.map(y=>{return {...y.data(), key:y.id}}));
      console.log(p);
      (async x=>{
        for (let i = 0; i < p.length; i++) {
          const product = p[i];
          console.log(product);
          await store.collection(`productsBackup`).doc(product.key).set(product)
          this.backupsku = product.sku
        }
        this.backupsku = null
      })()
    },
    async getWarehouses(){
      return new Promise(async (res, rej) => {
        this.loading = true
        this.countries = [
          "KSA",
          "Saudi Arabia",
          "SA",
          "Bahrain",
          "BH",
          "Palestine",
          "Kuwait",
          "KW",
          "Libya",
          "LY",
          "JO",
          "Jordan",
          "UAE",
          "AE",
          "United Arab Emirates",
          "OM",
          "Oman",
          "Iraq",
          "IQ",
          "PS",
          "Qatar",
          "Lebanon",
          "Senegal",
          "QA",
          "LB",
          "SN",
          "MR",
          "Côte d'Ivoire",
          "CI",
          "Mauritania",
          "MA",
          "Morocco",
          "EG",
          "Egypt",
          "YE",
          "Yeman",
          "YE",
          "Yeman",
          "CN",
          "China",
        ].map(x=>x.toUpperCase())
        const whs = await store.collection('warehouses')
        .get()
        .then(x=>x.docs.map(y=>{return {...y.data(), key:y.id, text:`${y.data().name} ${y.data().country}`}}))
        this.warehouses = whs.filter(x=>!x.lock)
        console.log(this.warehouses)
        this.loading = false
        res()
      })
    },
    removeWearhouse(k){
			this.selectedProduct.warehouses.splice(k, 1)
		},
		addWarehouse(key){
			console.log('a')
			this.selectedProduct.warehouses.push({
				warehouse:'',
				quantity:0,
			})
    },
    async updateProduct() {
      console.log(this.selectedProduct)
      await store.collection('products').doc(this.selectedProduct.key).update(this.selectedProduct)
      await this.getProducts(this.selectedProduct.key)
      this.loadWarehouseProducts()
    },
    async loadWarehouseProducts(){
      if(this.selectedWarehouse) {
        this.loading = true
        this.selectedWarehouse.products = []
        let a  = this.products.filter(x=>x.warehouses && x.warehouses.map(x=>x.warehouse).includes(this.selectedWarehouse.name))
        for (let kk = 0; kk < a.length; kk++) {
          const item = a[kk];
          for (let jj = 0; jj < item.warehouses.length; jj++) {
            const wcount = item.warehouses[jj];
            wcount.reserved = 0
            wcount.expected = 0
          }
        }
        let o = await this.getReservedOrders()
        console.log('this.selectedWarehouse.name', this.selectedWarehouse.name)
        console.log('o.filter(x=>x.reserved_wh && x.warehouse)', o.filter(x=>x.reserved_wh && x.warehouse))
        console.log('o.filter(x=>x.reserved_wh && x.warehouse)', o.filter(x=>x.reserved_wh && x.warehouse))
        let of = o.filter(x=>x.reserved_wh && x.warehouse).filter(x=>x.warehouse.warehouse == this.selectedWarehouse.name)
        console.log('of', of.length)
        let ofp = of.map(x=>x.products)
        for (let i = 0; i < of.length; i++) {
          const r = of[i];
          if(r.reservation) {

            for (let k = 0; k < r.reservation.length; k++) {
              const p = r.reservation[k];
              if(a.filter(x=>x.sku == p.sku)[0] && a.filter(x=>x.sku == p.sku)[0].warehouses && !a.filter(x=>x.sku == p.sku)[0].warehouses.filter(x=>x.warehouse == p.reservation_warehouse.warehouse)[0].reserved) {
                a.filter(x=>x.sku == p.sku)[0].warehouses.filter(x=>x.warehouse ==p.reservation_warehouse.warehouse)[0].reserved = 0
                a.filter(x=>x.sku == p.sku)[0].warehouses.filter(x=>x.warehouse == p.reservation_warehouse.warehouse)[0].reserved += parseFloat(p.quantity)
              } else {
                if(a.filter(x=>x.sku == p.sku)[0] && a.filter(x=>x.sku == p.sku)[0].warehouses){
                  a.filter(x=>x.sku == p.sku)[0].warehouses.filter(x=>x.warehouse == p.reservation_warehouse.warehouse)[0].reserved += parseFloat(p.quantity)
                }
              }
            }
          }

        }
        let r = await this.getPurchaseOrders()
        for (let i = 0; i < r.length; i++) {
          const or = r[i];
          for (let k = 0; k < or.items.length; k++) {
            const p = or.items[k];
            if(a.filter(x=>x.sku == p.sku).length && a.filter(x=>x.sku == p.sku)[0].warehouses.filter(x=>x.warehouse == or.wh)[0]) {
              if(!a.filter(x=>x.sku == p.sku)[0].warehouses.filter(x=>x.warehouse == or.wh)[0].expected) {
                a.filter(x=>x.sku == p.sku)[0].warehouses.filter(x=>x.warehouse == or.wh)[0].expected = 0
                a.filter(x=>x.sku == p.sku)[0].warehouses.filter(x=>x.warehouse == or.wh)[0].expected += parseFloat(p.quantity)
              } else {
                a.filter(x=>x.sku == p.sku)[0].warehouses.filter(x=>x.warehouse == or.wh)[0].expected += parseFloat(p.quantity)
              }
            } else {
              console.log(p.sku)
            }
          }
        }
        this.selectedWarehouse.products = a
			  this.$emit('snackbarNotification', `${this.selectedWarehouse.name} is loaded`, 'success')
        this.loading = false
      }
    },
    async addProduct(){
			let product = {
				item_name:this.nName,
				sku:this.nSKU,
			}
			let x = await db.ref(`products`)
			.push(product);
      product.key = x.key;
      product.warehouses = []
			await store.collection('products').doc(product.key).set(product)
			await store.collection('productsLive').doc(product.key).set(product)
			this.products.push(product);
			this.dialogAdd = false
			this.selectedProduct = product;
			this.$emit('snackbarNotification', `${product.item_name} is added`, 'success')

    },
    convertToCSV(arr) {
      const array = [Object.keys(arr[0])].concat(arr)
      return array.map(it => {
        return Object.values(it).toString()
      }).join('\n')
    },
    exportWarehouseh(){
      console.log(this.selectedWarehouse.products)
      let a = this.convertToCSV(this.selectedWarehouse.products.map(x=>{
        let p = this.fullProducts.filter(y=> y.key == x.key)[0]
        let r = x.warehouses.filter(x=>x.warehouse==this.selectedWarehouse.name)[0].reserved
        let e = x.warehouses.filter(x=>x.warehouse==this.selectedWarehouse.name)[0].expected
        return {
          item_name:x.item_name,
          name_ar:p ? p.name_ar : '',
          sku: x.sku,
          quantity:x.warehouses.filter(x=>x.warehouse==this.selectedWarehouse.name)[0].quantity,
          reserved:r?r:0,
          expected:e?e:0,
          account_id: this.laravelProducts.filter(l=>l.sku == x.sku).length && this.laravelProducts.filter(l => l.sku == x.sku).filter(l => l.account_id).length ? this.laravelProducts.filter(l => l.sku == x.sku).filter(l => l.account_id)[0].account_id : 0
        }
      }))
      let csvContent = "data:text/csv;charset=utf-8," 
      var encodedUri = encodeURI(csvContent + a);
      var link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", `${this.selectedWarehouse.name}_report.csv`);
      document.body.appendChild(link); // Required for FF

      link.click();
    },
    async getReservedOrders() {
      return new Promise(async (res, rej)=>{
        let o = await store.collection("leads")
        .where("reserved_wh", "==", true)
        .get().then(x=>x.docs.map(y=>{
          return {
            ...y.data(),
          }
        }))
        console.log('reserve orders', o)
        res(o)
      })
    },
    async getPurchaseOrders() {
      return new Promise(async (res, rej)=>{
        let o = await store.collection("purchaseOrders")
        .where("status", "==", 'Purchase')
        .get().then(x=>x.docs.map(y=>{
          return {
            ...y.data(),
          }
        }))
        console.log('Purchase orders', o)
        res(o)
      })
    },
  },
  props:{
		superAdmin:{
			required:true
		},
		userName:{
			default:null
    },
    userRole: {
      required: true,
      default: 'user'
    },
    beta: {
      required: true,
      default: false
    },
    superAdmin: {
      required: true,
      default: false
    },
  },
  computed:{
    
  },
  async created(){
    await this.loadLaravelProducts()
    await this.getProducts()
    await this.getWarehouses()

    // let o = await db.ref('countries/171').once('value').then(x=>x.val())
    // await db.ref('countries/250').update(o)
  }
}
</script>

<style>
.tokenField * {
  color:white !important;
}
</style>
